import React, { useState } from 'react'
import { useBlockEffect, useEditor } from '@smartfire/js-block-engine'
import style from './style.module.scss'
import apiFetch from '@wordpress/api-fetch'
import { menuItemParams } from '../../types'
import clsx from 'clsx'

type Props = {
    subMenu: menuItemParams[]
}

const SubMenu: React.FC<Props> = ({ subMenu }) => {
    const { isEditing } = useEditor()
    const [subMenuCpy, setSubMenuCpy] = useState(subMenu)

    useBlockEffect(() => {
        if (isEditing) {
            apiFetch({
                path: '/smartfire/submenu',
                parse: false,
            })
                .then((res: any) => res.json())
                .then((data) => {
                    setSubMenuCpy(data)
                })
        }
    }, [isEditing])

    return (
        <div className={style.subMenu}>
            <div className={style.content}>
                <span>© Fédération française de handball</span>
                <div className={style.links}>
                    {subMenuCpy?.length &&
                        subMenuCpy.map((el, i) => (
                            <a
                                key={i}
                                className={clsx(el.classes)}
                                href={el.url}
                                target={el.target}
                                rel={el.target ? 'noopener noreferrer' : ''}
                            >
                                {el.title}
                            </a>
                        ))}
                    <button
                        //@ts-ignore
                        onClick={() => Didomi?.preferences?.show()}
                    >
                        Centre de consentements
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SubMenu
